export default "__VITE_ASSET__UsjeCVeL__"